<template>
  <v-app id="inspire">
    <smenubar v-model="drawer"></smenubar>
    <sheader @showDrawer="showDrawer"></sheader>
    <v-main>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- <sfooter></sfooter> -->
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import sheader from "@/components/layout/store/seller/Header";
// import sfooter from "@/components/layout/store/seller/Footer";
import smenubar from "@/components/layout/store/seller/Sidebar";

export default {
  components: {
    sheader,
    smenubar,
    // sfooter
  },

  data() {
    return {
      isMobile: false,
      drawer: null
    };
  },

  computed: {
    windowWidth() {
      return this.getWindowWidth();
    },
    ...mapState("storeSeller", ['sellerMenuMini']),
  },

  methods: {
    showDrawer(){
      this.drawer = !this.drawer
    },
    ...mapActions("storeSeller", ["getStoreDetail"]),
    getWindowWidth() {
      let screen = document.documentElement.clientWidth;
      if (screen <= 960) this.isMobile = true;
      else this.isMobile = false;
    }
  },

  created() {
    this.getStoreDetail();
    this.getWindowWidth();
    window.addEventListener("resize", this.getWindowWidth);
  },
  destroyed() {
    window.addEventListener("resize", this.getWindowWidth);
  }
};
</script>
